export default {"src":"/_next/static/media/rank_3.dc52be29.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};